import L from "leaflet";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

export const redIcon = new L.Icon({
  iconUrl: "./imgs/marker-icon-red.png",
  iconRetinaUrl: "./imgs/marker-icon-2x-red.png",
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
